﻿import * as $form from './_form'

export interface ICriteriaItem {
    CriteriaId    : string;
    Values        : string;
    PreviousValues: string;
    Invert        : boolean;
    PreviousInvert: boolean;
}

export interface ISerializeFormOptions {
    fields?      : JQuery[];
    ranges?      : any[];
    checkboxes?  : JQuery[];
    flags?       : JQuery[];
    customFields?: any[];
}

export interface IDeserializeFormOptions {
    fields?      : JQuery[];
    ranges?      : any[];
    checkboxes?  : JQuery[];
    flags?       : JQuery[];
    customFields?: any[];
    criteriaData?: ICriteriaItem[];
}

function isEmptyValue(val:string): boolean {
    if (!val) return true;
    if (val.length === 0) return true;
    if (val === "-1") return true;
    if (val === "|") return true;
    else return false;
}

export function deserializeForm(options:IDeserializeFormOptions) : JQuery[] {
    var changedCriterias: JQuery[] = [];

    var optionDefaults:IDeserializeFormOptions = {
        fields: [],
        ranges: [],
        checkboxes: [],
        flags: [],
        customFields: [],
        criteriaData: []
    };

    console.log("deserializeForm: " + JSON.stringify(options.criteriaData));

    options = <IDeserializeFormOptions> $.extend(true, {}, optionDefaults, options);

    $.each(options.fields, function (idx, elem) {
        var currentCriteriaData:ICriteriaItem = getCriteria(elem, options.criteriaData);
        if (!currentCriteriaData || currentCriteriaData === null || currentCriteriaData == undefined) return;

        var prev = elem.val();

        if (isEmptyValue(prev) && isEmptyValue(currentCriteriaData.Values)) return;

        elem.val(currentCriteriaData.Values);
        
        console.log("field " + currentCriteriaData.CriteriaId + ": " + prev + " > " + currentCriteriaData.Values + " (" + (currentCriteriaData.Values != prev) + ")");

        if (currentCriteriaData.Values != prev) changedCriterias.push(elem);
    });

    $.each(options.checkboxes, function (idx, elem) {
        var currentCriteriaData: ICriteriaItem = getCriteria(elem, options.criteriaData);
        if (!currentCriteriaData || currentCriteriaData === null || currentCriteriaData == undefined) return;
        
        var prev = $form.getCheckboxlistValues(elem).join(",");

        $form.setCheckboxlistValues(elem, currentCriteriaData.Values);

        if (currentCriteriaData.Values != prev) changedCriterias.push(elem);
    });

    $.each(options.ranges, function (idx, elems) {
        var currentCriteriaData:ICriteriaItem = getCriteria(elems[0], options.criteriaData);
        if (!currentCriteriaData || currentCriteriaData === null || currentCriteriaData == undefined) return;
        
        var vals:string[] = currentCriteriaData.Values.split("|");

        var prev = elems[0].val() + "|" + elems[1].val();

        elems[0].val(vals[0]);
        elems[1].val(vals[1]);
        elems[2].slider("values", [vals[0], vals[1]]);

        console.log("slider " + currentCriteriaData.CriteriaId + ": " + prev + " > " + currentCriteriaData.Values + " (" + (currentCriteriaData.Values != prev) + ")");
        
        if (currentCriteriaData.Values != prev) changedCriterias.push(elems[0]);
    });

    $.each(options.flags, function (idx) {
        var elem:JQuery = options.flags[idx];

        var currentCriteriaData:ICriteriaItem = getCriteria(elem, options.criteriaData);
        if (!currentCriteriaData || currentCriteriaData === null || currentCriteriaData == undefined) return;

        var vals:string[] = [];
        elem.find("span.bcfla-checked").each(function () {
            vals.push($(this).attr("data-value"));
        });

        var loadedVals:string[] = currentCriteriaData.Values.split(",");

        elem.find("span").addClass("bcfla-label-unchecked");
        elem.find("span.bcfla-checked").removeClass("bcfla-checked");

        elem.find("span").each(function () {
            var val = $(this).attr("data-value");
            if (_.indexOf(loadedVals, val) >= 0) {
                $(this).addClass("bcfla-checked");
                $(this).removeClass("bcfla-label-unchecked");
            }
        });

        var valsString:string = vals.join(",");
        var loadedValsString:string = loadedVals.join(",");

        if (valsString != loadedValsString) changedCriterias.push(elem);
    });

    $.each(options.customFields, function (idx) {
        if (!options.customFields[idx]) {
            console.log("skippar customfield " + idx);
            return;
        }
        var elem:JQuery = options.customFields[idx](options.criteriaData);
        if (elem !== null) changedCriterias.push(elem);
    });

    return changedCriterias;
}

let dummyCriteria:ICriteriaItem = {
    CriteriaId: "-1",
    Values: "",
    PreviousValues: "",
    Invert: false,
    PreviousInvert: false
};

export function getCriteria(elem:JQuery, criteriaData:ICriteriaItem[]) : ICriteriaItem {
    if (!elem) return dummyCriteria;
    var criteriaId = elem.attr("data-criteria-id");
    if (!criteriaId || criteriaId.length === 0) return dummyCriteria;
    return _.find(criteriaData, function (c: ICriteriaItem) { return c.CriteriaId == criteriaId; }) || dummyCriteria;
}

export function serializeForm(options:ISerializeFormOptions = {}) : ICriteriaItem[] {
    var list:ICriteriaItem[] = [];

    var optionDefaults:ISerializeFormOptions = {
        fields: [],
        ranges: [],
        checkboxes: [],
        flags: [],
        customFields: []
    };

    options = <ISerializeFormOptions> $.extend(true, {}, optionDefaults, options);

    $.each(options.fields, function (idx, elemSelector) {
        var elem = $(elemSelector);
        if (elem.length > 0 && elem.parents(".search-section-disabled").length === 0) { // elem exists, and no parents has a disabled class
            var obj:ICriteriaItem = {
                CriteriaId: elem.attr("data-criteria-id"),
                Values: elem.val(),
                PreviousValues: elem.attr("data-previous-value"),
                PreviousInvert: (elem.attr("data-previous-invert") == "true"),
                Invert: false
            };
            list.push(obj);
        }
    });

    $.each(options.ranges, function (idx) {
        if (options.ranges[idx].length > 0 && options.ranges[idx][0].length > 0 && options.ranges[idx][0].parents(".search-section-disabled").length === 0) { // elem exists, and no parents has a disabled class
            var obj:ICriteriaItem = {
                CriteriaId: options.ranges[idx][0].attr("data-criteria-id"),
                Values: options.ranges[idx][0].val() + "|" + options.ranges[idx][1].val(),
                PreviousValues: options.ranges[idx][0].attr("data-previous-value"),
                PreviousInvert: (options.ranges[idx][0].attr("data-previous-invert") == "true"),
                Invert: false
            };
            list.push(obj);
        }
    });

    $.each(options.checkboxes, function (idx, elemSelector) {
        var elem = $(elemSelector);
        if (elem.length > 0 && elem.parents(".search-section-disabled").length === 0) { // elem exists, and no parents has a disabled class
            var obj:ICriteriaItem = {
                CriteriaId: elem.attr("data-criteria-id"),
                Values: $form.getCheckboxlistValues(elemSelector).join(","),
                PreviousValues: elem.attr("data-previous-value"),
                PreviousInvert: (elem.attr("data-previous-invert") == "true"),
                Invert: false
            };
            list.push(obj);
        }
    });

    $.each(options.flags, function (idx, elemSelector) {
        var elem = $(elemSelector);
        if (elem.length > 0 && elem.parents(".search-section-disabled").length === 0) { // elem exists, and no parents has a disabled class
            var vals:string[] = [];

            elem.find("span.bcfla-checked").each(function () {
                vals.push($(this).attr("data-value"));
            });

            var obj:ICriteriaItem = {
                CriteriaId: elem.attr("data-criteria-id"),
                Values: vals.join(","),
                PreviousValues: elem.attr("data-previous-value"),
                PreviousInvert: (elem.attr("data-previous-invert") == "true"),
                Invert: false
            };
            list.push(obj);
        }
    });

    $.each(options.customFields, function (idx) {
        var criteria = options.customFields[idx]();
        if (criteria !== null) list.push(criteria);
    });

    return list;
}

export interface IResetOptions {
    fields?      : JQuery[];
    checkboxes?  : JQuery[];
    sliders?     : JQuery[];
    flags?       : JQuery[];
    customFields?: any[];
}

function addToChangedCriterias(changedCriterias:JQuery[], elem:JQuery) : JQuery[] {
    if (_.any(changedCriterias, function (item: JQuery) { return item.attr("data-criteria-id") == elem.attr("data-criteria-id"); })) {
        return changedCriterias;
    }
    
    changedCriterias.push(elem);
    return changedCriterias;
}

export function reset(options:IResetOptions) : JQuery[] {
    var changedCriterias:JQuery[] = [];

    var optionDefaults: IResetOptions = {
        fields: [],
        checkboxes: [],
        sliders: [],
        flags: [],
        customFields: []
    };

    options = <IResetOptions> $.extend(true, {}, optionDefaults, options);

    $.each(options.fields, function (idx, elem:JQuery) {
        if (elem.length === 0) return;
        var val = <string> elem.val();
        var def = elem.attr("data-default-value");
        if (def === undefined) def = "";
        if (val != def) {
            console.log("criteria " + elem.attr("data-criteria-id") + ", val: " + val + ", def: " + def);
            addToChangedCriterias(changedCriterias, elem);
        }
        elem.val(def);
    });

    $.each(options.checkboxes, function (idx, elem:JQuery) {
        var valsBefore = $form.getCheckboxlistValues(elem).join(",");
        elem.find("button.bcfla-checked").removeClass("bcfla-checked");
        var def = elem.attr("data-default-value");
        elem.find("button[data-value='" + def + "']").addClass("bcfla-checked");
        var valsAfter = $form.getCheckboxlistValues(elem).join(",");
        if (valsBefore != valsAfter) addToChangedCriterias(changedCriterias, elem);
    });

    $.each(options.sliders, function (idx, elem:JQuery) {
        if (elem.slider("option", "range")) {
            elem.slider("values", [0, 0]);
        } else {
            elem.slider("value", 0);
        }
    });

    $.each(options.flags, function (idx, elem: JQuery) {
        var valsBefore:string[] = [];
        elem.find("span.bcfla-checked").each(function () {
            valsBefore.push($(this).attr("data-value"));
        });

        elem.find("span").addClass("bcfla-label-unchecked");
        elem.find(".bcfla-checked").removeClass("bcfla-checked");

        if (valsBefore.length > 0) addToChangedCriterias(changedCriterias, elem);
    });

    $.each(options.customFields, function (idx) {
        options.customFields[idx](changedCriterias);
    });

    return changedCriterias;
}

export function setPreviousValue(elem:JQuery, criteriaData:ICriteriaItem) : void {
    elem.attr("data-previous-value", criteriaData.Values);
    elem.attr("data-previous-invert", criteriaData.Invert.toString());
}

export function hide() : void {
    $("#bcfla-sidenav").removeClass("open");
    $("#bcfla-sidenav-overlay").removeClass("open");
}